import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "comment-list-item" }
const _hoisted_2 = { class: "comment-head" }
const _hoisted_3 = {
  key: 0,
  class: "user-tag is-anon"
}
const _hoisted_4 = { class: "comment-time" }
const _hoisted_5 = {
  key: 2,
  class: "comment-target"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserTag = _resolveComponent("UserTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.comment.is_anon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Anonymous"))
        : (_openBlock(), _createBlock(_component_UserTag, {
            key: 1,
            user: _ctx.comment.user_created,
            full: 1
          }, null, 8, ["user"])),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formatTS(_ctx.comment.created_at)), 1),
      (_ctx.targetType !== _ctx.comment.target_type.index)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            (_ctx.comment.target_type.index == 'ALBUM')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.comment.artist_id?.name) + " : " + _toDisplayString(_ctx.comment.album_id?.title), 1))
              : (_ctx.comment.target_type.index == 'ARTIST')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.comment.artist_id?.name), 1))
                : (_ctx.comment.target_type.index == 'VERSION')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.comment.version_id?.title), 1))
                  : (_ctx.comment.target_type.index === 'ITEM_ALBUM')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (_ctx.targetType == 'VERSION')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "#" + _toDisplayString(_ctx.comment.version_item?.rank_order + 1) + " " + _toDisplayString(_ctx.comment.artist_id?.name) + " - " + _toDisplayString(_ctx.comment.album_id?.title), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.comment.artist_id?.name) + " - " + _toDisplayString(_ctx.comment.album_id?.title) + " / " + _toDisplayString(_ctx.comment.version_id?.title), 1))
                      ], 64))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.comment.target_type.index), 1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "comment-content",
      innerHTML: _ctx.markdown.render(_ctx.comment.content)
    }, null, 8, _hoisted_12)
  ]))
}